module.exports = __webpack_public_path__ + "img/menu-icon.927a7c6d.svg";